module.exports = __webpack_public_path__ + "static/instapay_share-10f501e9f45e4f19551c4cea2d5aade2.png";